import PlateDetailSection from './PlateDetailSection';

export default PlateDetailSection;
